export default "https://cdn-static.gokick.com/assets/0b66121a981ee5d829a48c6e4fd91363599ac59b/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";